import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-confirmation-toggle',
  templateUrl: './confirmation-toggle.component.html',
  styleUrls: ['./confirmation-toggle.component.sass'],
})
export class ConfirmationToggleComponent implements OnInit {
  @Input() action = '';
  @Input() icon = '';
  @Input() classModifier = 'btn-sm';
  @Output() confirmClick = new EventEmitter<number>();
  confirmStep = false;

  constructor() {}

  ngOnInit() {}

  goToConfirmStep() {
    this.confirmStep = true;
  }

  cancel() {
    this.confirmStep = false;
  }

  confirm() {
    this.confirmStep = false;
    this.confirmClick.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/common/confirmation-toggle/confirmation-toggle.component.ts